module.exports = __webpack_public_path__ + "./Frank2_403bc006cf3a83ba377437b0492ebfb0.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/sectionTalking/2022/Frank2.png
// module id = 553
// module chunks = 0